import { Entity } from './entity';
import { Scene, GameObjects } from 'phaser'

export class Sprite {
  image: GameObjects.Image

  constructor(readonly spriteName: string, readonly spriteScale: number = 1) {}

  addImage(scene: Scene): GameObjects.Image {
    var config = {
      key: this.spriteName
    }

    this.image = scene.make.image(config).setScale(this.spriteScale)
    return this.image
  }
}
